export var OrderStatuses;
(function (OrderStatuses) {
    OrderStatuses["pending"] = "pending";
    OrderStatuses["cancelled"] = "cancelled";
    OrderStatuses["forDelivery"] = "for_delivery";
    OrderStatuses["completed"] = "completed";
    OrderStatuses["refunded"] = "refunded";
})(OrderStatuses || (OrderStatuses = {}));
